const initialState = {
    resolutions: {},
    responses: {},
    types: {},
};

const reduceCounts = data =>
    data.reduce(
        (stats, { key, count }) => ({
            ...stats,
            [key]: count,
        }),
        {}
    );

function reducer(state = initialState, action) {
    if (action.type === 'ISSUE_SLA_STATISTICS_SUCCESS') {
        return {
            ...state,
            resolutions: {
                ...reduceCounts(action.payload.resolutionSla.counts),
            },
            responses: {
                ...reduceCounts(action.payload.responseSla.counts),
            },
        };
    }

    if (action.type === 'ISSUE_TYPE_STATISTICS_SUCCESS') {
        return {
            ...state,
            types: {
                ...reduceCounts(action.payload.type.counts),
            },
        };
    }

    return state;
}

export default reducer;
